import * as MM from 'moment-timezone'
// import * as MM from 'moment'
import 'moment/locale/th'

const mmtz = MM

mmtz.locale('th')
mmtz.tz('Asia/Bangkok').format()
mmtz.utc(7)
export const Moment = mmtz
